const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/GrundversicherungField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const GrundversicherungField = generateMetaKatDropDownField(
    'd03a7c31-60a8-4f65-a64f-92934172fb67',
    'GrundversicherungField'
);

export default GrundversicherungField;
